/**
 * Tells Horizon's cart (count bubble, drawer) that something outside its own product form added
 * to the cart, e.g. the Auto Delivery builder posting to /cart/add.js.
 * Usage: window.lytesCartRefresh([{ id: variantId, quantity: 1 }]);
 */
window.lytesCartRefresh = async function lytesCartRefresh(lines = []) {
  try {
    const [{ CartLinesUpdateEvent }, ajaxCart] = await Promise.all([
      import('@shopify/events'),
      fetch(`${window.Theme?.routes?.cart_url || '/cart'}.js`, { headers: { Accept: 'application/json' } }).then((r) => r.json()),
    ]);
    const deferred = CartLinesUpdateEvent.createPromise();
    document.dispatchEvent(
      new CartLinesUpdateEvent({
        action: 'add',
        context: 'product',
        lines: lines.map((line) => ({ merchandiseId: String(line.id), quantity: line.quantity || 1 })),
        promise: deferred.promise,
      })
    );
    deferred.resolve({
      cart: CartLinesUpdateEvent.createCartFromAjaxResponse(ajaxCart),
      detail: { items: ajaxCart.items, source: 'lytes', sourceId: 'lytes', itemCount: ajaxCart.item_count, didError: false },
    });
  } catch (error) {
    // The cart still updated; only the header count waits for the next page load
    console.warn('lytes-cart-refresh:', error);
  }
};
